import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// 猫眼APP
// 点评APP
export default {
  appName: 'maoyan',
  useKNB: true,
  sellChannel: 5,
  theme: 'maoyan',
  gotoShowHomeTab: function gotoShowHomeTab() {
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var url, a;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            url = 'maoyan://maoyan.com/showhome ';
            a = document.createElement('a');
            a.href = url;
            a.click();
            return _context.abrupt("return");
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  }
};